import React from 'react'

import { Button, ConfirmModal, Tooltip, useModalContext } from '@fourthwall/components'

import * as S from './KitGetStarted.styled'

const KIT_MODAL_THRESHOLD = 1000
const KIT_BLOCK_SYNC_THRESHOLD = 10000

type KitGetStartedProps = {
  onGetStarted: () => Promise<void>
  isLoading: boolean
  dataCount: number
}

export const KitGetStarted = ({ onGetStarted, isLoading, dataCount }: KitGetStartedProps) => {
  const { open } = useModalContext()

  const handleGetStarted = async () => {
    try {
      await onGetStarted()
    } catch (error) {
      console.error('Failed to get started with Kit:', error)
    }
  }

  const handleSyncClick = () => {
    if (dataCount > KIT_MODAL_THRESHOLD) {
      open(ConfirmModal, {
        title: 'Sync subscriber data with Kit?',
        text: 'This will sync your members and newsletter subscribers to Kit. This action may take a few minutes to complete and can increase your monthly Kit charges.',
        confirmLabel: 'Sync Data',
        confirmAppearance: 'primary',
        onConfirm: handleGetStarted,
      })
    } else {
      handleGetStarted()
    }
  }

  const blockSync = dataCount > KIT_BLOCK_SYNC_THRESHOLD

  return (
    <S.Container>
      <S.Title>Get Started with Kit</S.Title>
      <S.Description>
        Click to button below to sync your members and newsletter subscribers to Kit.
      </S.Description>
      <S.ButtonContainer>
        {blockSync ? (
          <Tooltip
            reference={
              <Button label="Sync Data" appearance="primary" disabled onClick={handleSyncClick} />
            }
          >
            <S.BlockSyncMessage>
              <p>
                You're about to sync a large subscriber list. This will significantly increase your
                monthly Kit charges.
              </p>
              <p>
                If you still want to sync this data, please contact support@fourthwall.com for
                support.
              </p>
            </S.BlockSyncMessage>
          </Tooltip>
        ) : (
          <Button
            label="Sync Data"
            appearance="primary"
            loading={isLoading}
            disabled={isLoading}
            onClick={handleSyncClick}
          />
        )}
      </S.ButtonContainer>
    </S.Container>
  )
}
